import { DrupalResponse } from '@repositories/auth/typings';

export enum Status {
  OK = 'ok',
  RENEW_ACCOUNT = 'renew-account',
  DATE_INCOMPATIBLE = 'date-incompatible',
  CANNOT_AUTH_USER = 'cannot-auth-user',
  OKTA_ERROR = 'okta-error',
  AUTH_CONTROLLER_ERROR = 'auth-controller-error',
}
export interface UserAuthenticate {
  status: Status;
  redirect?: string;
  isOktaIndividualId: boolean;
}

export interface ClientServerDate {
  isCorrectClientDate: boolean;
}

export type BackendAuthRes = {
  backend?: UserAuthenticate | Error;
  drupal?: DrupalResponse | Error | Status;
  status: Status | DrupalResponse;
};
